import * as yup from 'yup';
import { I18n } from 'react-redux-i18n';

const REQUIRED_FIELD = I18n.t('auth.requiredField');

const PHONE_MIN_LENGTH = 5;
const PHONE_MAX_LENGTH = 20;

const PASSWORD_MAX_LENGTH = 20;

const REAL_NAME_MIN_LENGTH = 2;
const REAL_NAME_MAX_LENGTH = 25;

const EMAIL_MIN_LENGTH = 5;
const EMAIL_NAME_MAX_LENGTH = 254;

export const getValidators = () => {
  const basePhoneRule = yup
    .string()
    .min(
      PHONE_MIN_LENGTH,
      I18n.t('auth.minLength', { minLength: PHONE_MIN_LENGTH })
    )
    .max(
      PHONE_MAX_LENGTH,
      I18n.t('auth.maxLength', { maxLength: PHONE_MAX_LENGTH })
    );

  const baseEmailRule = yup
    .string()
    .email(I18n.t('register.errors.email.wrong'))
    .min(
      EMAIL_MIN_LENGTH,
      I18n.t('auth.minLength', { minLength: EMAIL_MIN_LENGTH })
    )
    .max(
      EMAIL_NAME_MAX_LENGTH,
      I18n.t('auth.maxLength', { maxLength: EMAIL_NAME_MAX_LENGTH })
    );

  const baseRealNameRule = yup
    .string()
    .min(
      REAL_NAME_MIN_LENGTH,
      I18n.t('auth.minLength', { minLength: REAL_NAME_MIN_LENGTH })
    )
    .max(
      REAL_NAME_MAX_LENGTH,
      I18n.t('auth.maxLength', {
        maxLength: REAL_NAME_MAX_LENGTH,
      })
    );

  const passwordRule = yup
    .string()
    .required(REQUIRED_FIELD)
    .min(8, I18n.t('register.errors.password.length'))
    .max(
      PASSWORD_MAX_LENGTH,
      I18n.t('register.errors.password.maxLength', {
        maxLength: PASSWORD_MAX_LENGTH,
      })
    );

  const childValidation = yup.object().shape({
    name: yup
      .string()
      .required(REQUIRED_FIELD)
      .matches(
        /^[a-zA-Z0-9_]{3,16}$/,
        I18n.t('register.errors.nickname.wrong')
      ),
    password: passwordRule,
  });

  const parentValidation = yup.object().shape({
    email: baseEmailRule.required(REQUIRED_FIELD),
    password: passwordRule,
    phone: basePhoneRule.required(REQUIRED_FIELD),
  });

  return { childValidation, parentValidation };
};
